import {FieldMap, FieldOperations, OpsCategories, SqlOperation, TableI} from '../Types';
import {nanoid} from "@reduxjs/toolkit";


let fieldOperations: FieldOperations = {
    email: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    prize: [...OpsCategories.null, ...OpsCategories.like],
    sent: [...OpsCategories.eq],
    dt: [...OpsCategories.range],
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
};

export const EmailTable: TableI = {
    backend: "/342/",
    title: {
        ua: "Email",
        en: "Замовлення",
    },
    pk: 'id',
    action: "email342WinnersEmailAction",
    defaultOrderedBy: "prize",
    defaultOrderedWay: "ASC",
    defaultPerPage: 50,
    orderByFields: {
        "id": {ua: "ID", en: "№"},
        "dt": {ua: "Створено", ru: "Дата"},
        "prize": {ua: "Приз", ru: "Дата"},
    },
    fieldOperations: fieldOperations,
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "№"}, type: "number",
            applyTransform: true
        },
        {
            key: "email",
            type: 'email',
            applyTransform: true,
            detailed: true,
            inline: true,
            title: {ua: "Email"}
        },

        {
            key: "prize",
            title: {ua: "Приз"},
            type: 'string',
            inline: true,
            detailed: true,
            applyTransform: true
        },
        {
            key: "sent",
            title: {ua: "Відправлено"},
            type: 'boolean',
            applyTransform: true,
            detailed: true,
            inline: true
        },
        {
            key: "dt",
            title: {ua: "Створено"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: true,
            inline: true,
        },
        {
            key: "id",
            detailed: true,
            title: {ua: "ID"},
            type: "number",
            applyTransform: true
        },
    ]
}

